import * as React from 'react';
import { ReactElement, useRef } from 'react';
import SearchFilter from '../../components/groups/SearchFilter';
import ContentLayout from '../../components/common/layouts/ContentLayout';
import GroupList, { GroupsRef } from 'components/groups/GroupList';
import { useCLOSETGroupsInitialSearchParams } from '../../hooks/groups/useCLOSETGroupsInitialSearchParams';

const GroupsContainer = (): ReactElement => {
  const ref = useRef<GroupsRef>(null);
  const initialSearchParams = useCLOSETGroupsInitialSearchParams();

  return (
    <ContentLayout pageTitle={'Group'}>
      <SearchFilter groupsRef={ref} initialSearchParams={initialSearchParams} />
      <GroupList groupsRef={ref} initialSearchParams={initialSearchParams} />
    </ContentLayout>
  );
};

export default GroupsContainer;
